import { isDatoSporsmal } from '../../sporsmalsflyt/dato/dato-types';
import { BesvartSporsmal } from '../../sporsmalsflyt/reducer/current-steg';
import { BesvartSporsmalSide, isCurrentSporsmalSide } from '../../sporsmalsflyt/sporsmalSide/sporsmalSide-types';
import { isUtleggSporsmal } from '../../sporsmalsflyt/utlegg/utlegg-types';

export const fixSerializedSporsmal = (besvartSporsmal: any): BesvartSporsmal => {
    if (isUtleggSporsmal(besvartSporsmal)) {
        return {
            ...besvartSporsmal,
            utleggslinjer: besvartSporsmal.utleggslinjer.map((utleggslinje) => ({
                ...utleggslinje,
                dato: utleggslinje.dato,
            })),
        };
    }
    if (isDatoSporsmal(besvartSporsmal)) {
        return {
            ...besvartSporsmal,
            dato: besvartSporsmal.dato,
        };
    }
    if (isCurrentSporsmalSide(besvartSporsmal)) {
        return {
            ...besvartSporsmal,
            sporsmalsflytCollection: {
                ...besvartSporsmal.sporsmalsflytCollection,
                currentSporsmalList:
                    besvartSporsmal.sporsmalsflytCollection.currentSporsmalList.map(fixSerializedSporsmal),
            },
        } as BesvartSporsmalSide;
    }
    return besvartSporsmal;
};

export const isValidForCache = (kundenummer: string, besvarteSporsmal: BesvartSporsmal[]): boolean => {
    return !!kundenummer && besvarteSporsmal.length > 1;
};
